import { trace } from 'rytm-helpers'
import { tns } from 'tiny-slider'

let carousels = []
const CAROUSEL_SELECTOR = ".r-carousel"
const CAROUSEL_PREV_CLASS = "r-carousel-prev"
const CAROUSEL_NEXT_CLASS = "r-carousel-next"

// init carousels
export const initCarousels = () => {
  const list = [...document.querySelectorAll(CAROUSEL_SELECTOR)]
  list.forEach(initCarousel)
  addEventListeners()
}
// destroy all carousels
export const destroyCarousels = () => {
  carousels.forEach(destroyCarousel)
  carousels = []
  removeEventListeners()
}
// init tiny-slider on dom element
export const initCarousel = (el, index) => {
  // https://github.com/ganlanyuan/tiny-slider#options
  const wW = window.innerWidth;
  const params = {
    container: el,
    mode: "carousel", // "carousel" / "gallery"
    axis: "horizontal", // "horizontal" / "vertical"
    startIndex: el.dataset.startIndex ? el.dataset.startIndex : 0,
    items: el.dataset.items ? el.dataset.items : 1,
    responsive: getRowlCarouselResponsive(el),
    gutter: 0,
    edgePadding: el.dataset.edgePadding ? (parseInt(el.dataset.edgePadding) * wW * .01) : 0,
    fixedWidth: false,
    autoWidth: false,
    viewportMax: false,
    slideBy: 1, // number / "page",
    center: el.dataset.center ? el.dataset.center == "true" : false,
    controls: false,
    nav: el.dataset.nav ? el.dataset.nav : false,
    arrowKeys: el.dataset.arrowKeys ? el.dataset.arrowKeys == "true" : false,
    speed: 300,
    autoplay: el.dataset.autoplay ? el.dataset.autoplay == "true" : false,
    autoplayTimeout: el.dataset.autoplayTimeout ? el.dataset.autoplayTimeout : 5000,
    autoplayPosition: "top", // play, stop pos: "top" / "bottom",
    autoplayText: [ el.dataset.autoplayTxtStart ? el.dataset.autoplayTxtStart : "start", el.dataset.autoplayTxtStop ? el.dataset.autoplayTxtStop : "stop"],
    autoplayHoverPause: false,
    loop: el.dataset.loop ? el.dataset.loop == "true" : false,
    autoHeight: el.dataset.autoHeight ? el.dataset.autoHeight : false,
    mouseDrag: el.dataset.mouseDrag ? el.dataset.mouseDrag : false,
    // FIX 
    preventScrollOnTouch: 'auto',
    preventScrollOnTouch: 'force',
  }
  const ts = tns(params)
  // add index changed event
  ts.events.on('indexChanged', onSliderIndexChanged)
  // handle class list update
  onSliderIndexChanged(ts.getInfo())
  // push tiny slider instance to carousels list
  carousels.push( ts )
}
const getRowlCarouselResponsive = (el) => {
  const items = el.dataset.items ? el.dataset.items : 1
  return {
    0: {
      items: el.dataset.items0 ? el.dataset.items0 : items
    },
    576: {
      items: el.dataset.items576 ? el.dataset.items576 : items
    },
    768: {
      items: el.dataset.items768 ? el.dataset.items768 : items
    },
    992: {
      items: el.dataset.items992 ? el.dataset.items992 : items
    },
    1200: {
      items: el.dataset.items1200 ? el.dataset.items1200 : items
    },
    1400: {
      items: el.dataset.items1400 ? el.dataset.items1400 : items
    },
    1600: {
      items: el.dataset.items1600 ? el.dataset.items1600 : items
    },
  }
}
// add event listeners for custom controls
const addEventListeners = () => {
  document.addEventListener("click", onDocumentClick)
}
// remove event listeners for custom controls
const removeEventListeners = () => {
  document.removeEventListener("click", onDocumentClick)
}
// destroy tiny-slider instance
const destroyCarousel = (ts, index) => {
  ts.events.off('indexChanged', onSliderIndexChanged)
  ts.destroy()
}

// ### Slider events ###
const onSliderIndexChanged = (info) => {
  // update nav state
  updateNavState(info)
  // add active-x class names...
  sliderItemsClassUpdate(info)
}
// 
const updateNavState = (info) => {
  const id = info.container.id
  const prevs = [...document.querySelectorAll(`.${CAROUSEL_PREV_CLASS}[href="#${id}"]`)]
  const nexts = [...document.querySelectorAll(`.${CAROUSEL_NEXT_CLASS}[href="#${id}"]`)]
  prevs.forEach((el) => {
    if (info.index === 0) {
      el.classList.add("disabled")
    } else {
      el.classList.remove("disabled")
    }
  })
  nexts.forEach((el) => {
    if (info.index >= info.slideCount - info.items) {
      el.classList.add("disabled")
    } else {
      el.classList.remove("disabled")
    }
  })
}
// adds active-x class names to slider items
const sliderItemsClassUpdate = (info) => {
  const list = [...info.container.querySelectorAll(".tns-item")]
  let cc = 0
  const max = 6
  list.forEach((el, index) => {
    if (index == info.index) {
      el.classList.add("active-current");
    } else {
      el.classList.remove("active-current");
    }
    for (let i = 1; i <= max; i++) {
      el.classList.remove("active-" + i)
    }
    if (el.classList.contains("tns-slide-active")) {
      cc++
      if (cc <= max) {
        el.classList.add("active-" + cc)
      }
    }
  })
}

// #######################
// ### DOM event listneres
const onDocumentClick = (e) => {
  const link = e.target.closest("a");
  if (link) {
    if (link.classList.contains(CAROUSEL_PREV_CLASS)) {
      e.preventDefault()
      onPrevClick(link)
    } else if (link.classList.contains(CAROUSEL_NEXT_CLASS)) {
      e.preventDefault()
      onNextClick(link)
    }
  }
}

// prev click
const onPrevClick = (trigger) => {
  const ts = getCarousel(trigger.getAttribute("href"))
  if (ts) {
    ts.goTo('prev')
  }
}
// next click
const onNextClick = (trigger) => {
  const ts = getCarousel(trigger.getAttribute("href"))
  if (ts) {
    ts.goTo('next')
  }
}
// ###############
// ### Helpers ###
const getCarousel = (selector) => {
  let c
  carousels.forEach((ts) => {
    const info = ts.getInfo()
    if (info.container.matches(selector)) {
      c = ts
      return c
    }
  })
  return c
}